module.exports = __webpack_public_path__ + "static/bjorlin_photo-300997938939ef5b9574d0e1b28102ad.png";